import { inject, Injectable, signal } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LocalStorageKeys } from '../../shared/constants/local-storage-keys';

const DEFAULT_LANG = 'en';
const SUPPORTED_LANGUAGES = [DEFAULT_LANG];

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  private readonly translate = inject(TranslateService);
  readonly currentLang = signal<string>(DEFAULT_LANG);

  init(): void {
    // Set fallback language
    this.translate.setFallbackLang(DEFAULT_LANG);

    // Determine active language: localStorage → browser → fallback
    const savedLang = localStorage.getItem(LocalStorageKeys.Language);
    const browserLang = navigator.language.split('-')[0]; // e.g., 'en-US' -> 'en'

    let activeLang = DEFAULT_LANG;

    if (savedLang && SUPPORTED_LANGUAGES.includes(savedLang)) {
      activeLang = savedLang;
    } else if (browserLang && SUPPORTED_LANGUAGES.includes(browserLang)) {
      activeLang = browserLang;
    }

    // Use the determined language
    this.translate.use(activeLang);
    this.currentLang.set(activeLang);
  }

  setLanguage(lang: string): void {
    if (!SUPPORTED_LANGUAGES.includes(lang)) {
      console.warn(`Language "${lang}" is not supported. Falling back to "${DEFAULT_LANG}".`);
      lang = DEFAULT_LANG;
    }

    localStorage.setItem(LocalStorageKeys.Language, lang);
    this.translate.use(lang);
    this.currentLang.set(lang);
  }
}
